import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of courses.
 */
export const getCourses = async (sorting, pagination, searchTerm, filters, fullList = false) => {
  let params = ''

  if (fullList) {
    params = '?limit=1000&state=Published'
  } else {
    params = configureRequestParams(sorting, pagination, searchTerm, filters)
  }

  try {
    return await axios.get(`/courses/${params}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Add a new course.
 * @param {object} payload - The course data to be added.
 */
export const addCourse = async (payload) => {
  try {
    return await axios.post('/courses/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Get a course.
 * @param {string} id - The course to get.
 */
export const getCourse = async (id) => {
  try {
    return await axios.get(`/courses/${id}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Update an course.
 * @param {object} payload - The course data to be updated.
 */
export const updateCourse = async (payload) => {
  try {
    return await axios.patch(`/courses/${payload.id}/`, payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes an course.
 * @param {string} id - The course id to be deleted.
 */
export const deleteCourse = async (id) => {
  try {
    return await axios.delete(`/courses/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
